module.exports = __webpack_public_path__ + "img/section_1_stamp.002589cc.png";